export function fireUnbxdOrder(unxPayload) {
  setTimeout(function () {
    if (window.Unbxd) {
      Unbxd.trackMultiple("order", unxPayload)
      console.log("Unbxd is defined")
    } else {
      console.log("Unbxd is not defined")
    }
  }, 2000);
}
// exportfireUnbxdOrder();



export function fireAutoSuggest(payload) {
  if (Unbxd && typeof Unbxd.track === 'function') {
    console.log('unbx')
    Unbxd.track('search', payload)
  } else {
    console.error('unbxdAnalytics.js is not loaded!')
  }
}
